export const GAME = {
  id: 555,
  height: 5847786,
  data: {
    icon: "/imgs/icons/asset/game.svg",
  },
};
